import { render } from "./TicketsHeaderList.vue?vue&type=template&id=5201a26c"
import script from "./TicketsHeaderList.vue?vue&type=script&lang=js"
export * from "./TicketsHeaderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__